module.exports = __webpack_public_path__ + "img/deaf_guide.d0345bbb.png";